import UserProfile from "../data";

export const getKeyCaseInsensitive = (obj, key) => {
    if (!key) return null
    return Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
}

export const replaceText = (text, searchPhrase, replacePhrase) => {
    if (!text || !searchPhrase || !replacePhrase) return text;
    return text.replace(new RegExp(searchPhrase, 'g'), replacePhrase);
}

export const validateLevelUser = (roles, app = '-') => {
    const userRoles = UserProfile.getUserData().level;
    const isView = roles.split(',').includes(userRoles);
    console.log('*******isView', isView, userRoles, app, roles);
    return isView;
}

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));